<template>
  <div class="corpo">
    <div class="container">
      <img
        class="capa"
        src="IMG_9711.png"
        alt=""
        style="border-radius: 10px; padding-top: 5px"
      />
      <div v-if="carregando">
        <img
          src="/loader.gif"
          alt=""
          width="50"
          class="mx-auto d-flex align-self-center"
        />
      </div>
      <div id="chartdiv" class="grafico"></div>
      <p class="mensagem1" v-html="mensagem1"></p>
      <div class="mensagem2" v-html="mensagem2"></div>
      <div
        class="flourish-embed flourish-cards"
        data-src="visualisation/10450883"
      ></div>
    </div>
  </div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import axios from "axios";

am4core.useTheme(am4themes_animated);

export default {
  name: "App",
  data() {
    return {
      carregando: true,
      favoraveis: null,
      contrarios: null,
      indecisos: null,
      semResposta: null,
      resultado: null,
      mensagem1: null,
      mensagem2: null,
    };
  },
  components: {},
  beforeCreate() {
    axios
      .get("https://wevfxt.deta.dev/")
      .then((resultado) => {
        this.favoraveis = resultado.data.favoraveis;
        this.indecisos = resultado.data.indecisos;
        this.contrarios = resultado.data.contrarios;
        this.semResposta = resultado.data.semResposta;
        this.mensagem1 = resultado.data.mensagem1;
        this.mensagem2 = resultado.data.mensagem2;

        this.carregando = false;
        // Gerar Gráfico
        let chart = am4core.create("chartdiv", am4charts.PieChart);
        chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

        chart.data = [
          {
            posicionamento: "Favoráveis",
            value: this.favoraveis,
            color: am4core.color("#73af48"),
          },
          {
            posicionamento: "Não participou",
            value: this.indecisos,
            color: am4core.color("#edad08"),
          },
          {
            posicionamento: "Contrários",
            value: this.contrarios,
            color: am4core.color("#cc503e"),
          },
        ];
        chart.radius = am4core.percent(70);
        chart.innerRadius = am4core.percent(40);
        chart.startAngle = 180;
        chart.endAngle = 360;

        var series = chart.series.push(new am4charts.PieSeries());
        series.dataFields.value = "value";
        if (series.dataFields.value == 0) {
          series.dataFields.value = "";
        }
        series.dataFields.category = "posicionamento";
        series.legendSettings.valueText = "{value.close}";
        series.legendSettings.itemValueText = "{value}";

        // Configuração Tamanho / Posicionamento / Labels, Rótulos
        // https://www.amcharts.com/docs/v4/tutorials/labels-inside-pie-chart-slices/
        // https://www.amcharts.com/docs/v4/chart-types/pie-chart/#Disabling_various_elements
        if (window.screen.width < 415) {
          series.ticks.template.disabled = true;
          series.alignLabels = false;
          series.labels.template.text = "{value.percent.formatNumber('#.0')}%";
          series.labels.template.radius = am4core.percent(-20);
          series.labels.template.fill = am4core.color("black");
          // Remover rótulos que são 0%
          // series.labels.template.adapter.add(
          //   "radius",
          //   function (radius, target) {
          //     if (
          //       target.dataItem &&
          //       target.dataItem.values.value.percent == 0
          //     ) {
          //       return 100;
          //     }
          //     return radius;
          //   }
          // );
        } else {
          series.alignLabels = true;
        }

        series.slices.template.cornerRadius = 10;
        series.slices.template.innerCornerRadius = 7;
        series.slices.template.draggable = false;
        series.slices.template.inert = true;

        series.slices.template.propertyFields.fill = "color";

        series.hiddenState.properties.startAngle = 90;
        series.hiddenState.properties.endAngle = 90;

        chart.legend = new am4charts.Legend();

        let credit = document.querySelector(
          "#chartdiv > div > svg > g > g:nth-child(2) > g:nth-child(2) > g > g:nth-child(3)"
        );
        credit.style.display = "none";
      })
      .finally();
  },
  mounted() {},
};
</script>

<style>
@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.2.0-beta1/dist/css/bootstrap.min.css");
@import url("https://fonts.googleapis.com/css2?family=Roboto+Condensed&display=swap");

#app {
  font-family: "Roboto Condensed", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.corpo {
  background-color: #096092;
  padding: 10px;
}
.container {
  background-color: #ffffff;
  border-radius: 10px;
}
.grafico {
  width: 100%;
  height: 360px;
  margin: 0 auto;
}
.mensagem1 {
  border-radius: 5px;
  font-size: 12px;
  padding: 10px;
  width: 50%;
  margin: 10px auto;
  background-color: #f1f1f1;
}
.mensagem2 {
  margin: 0 auto;
  width: 600px;
}
@media (max-width: 415px) {
  .container img.capa {
    width: 90%;
    padding-bottom: 20px;
  }
  .grafico {
    width: 95%;
  }
  .mensagem1 {
    width: 95%;
  }
  .mensagem2 {
    width: 95%;
  }
}
</style>
